export default __webpack_public_path__ + "static/media/AE.a470f92f.svg";